var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ContestEntryFormLayout,
    {
      attrs: {
        "load-state": _setup.loadState,
        "error-message": _setup.errorMessage,
        "current-step": 2,
        title: _setup.t("contestEntryForm.step2.title"),
        contest: _setup.microCmsContest,
      },
    },
    [
      _c(_setup.ContestEntryWorkSelectForm, {
        attrs: {
          "category-options": _setup.categoryOptions,
          "can-proceed": _setup.canProceed,
          novels: _setup.novels,
          "extra-field-items": _setup.extraFieldItems,
        },
        on: { back: _setup.onClickBack, next: _setup.onClickNext },
        model: {
          value: _setup.form,
          callback: function ($$v) {
            _setup.form = $$v
          },
          expression: "form",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }